import { user } from 'core';
import { HeaderStyles as Header } from 'ui/components';
import { Cycle, HeaderCart, HeaderSearch, HeaderLogo, HeaderNavBar } from './widgets';
import config from 'config';

const HeaderDesktopContainer = () => {
  const {
    data: { isBlocked: isUserBlocked },
  } = user.hooks.useUser();

  return (
    <>
      <Header.Component
        data-fixed={config.header.fixed}
        data-testid="header-desktop"
        data-small={isUserBlocked}
      >
        <Header.Container aria-labelledby="menu-nav" data-justify="space-between">
          <HeaderLogo />
          <Header.NavBar data-justify="right">
            <HeaderNavBar />
          </Header.NavBar>
          <HeaderCart />
        </Header.Container>
        {!isUserBlocked && <Header.Divider />}
        {!isUserBlocked && (
          <Header.Container aria-labelledby="sub-header" data-justify="space-between">
            <HeaderSearch />
            <Cycle />
          </Header.Container>
        )}
      </Header.Component>
      {config.header.fixed && <Header.Space data-small={isUserBlocked} />}
    </>
  );
};

export default HeaderDesktopContainer;
